const otherRoutes = [
    {
      path: "/validation",
      name: "validation",
      component: () => import("@/views/Validation.vue")
    }
  ];
  
  export default otherRoutes;
  